import React from 'react';
import {isMobile} from 'react-device-detect';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {useDebtPaymentPopupData} from '../../hooks/useDebtPaymentPopupData';
import Image from 'app/Components/Shared/Image/image';

const BankAccountMismatchPopup = ({props}) => {
  const {actions} = useDebtPaymentPopupData();

  const handleClose = () => {
    actions.setShowPopup({showPopUp: false});
  };

  return (
    <div className='bank-account-mismatch-popup'>
      <div className='debt-payment-popup-image'>
        <Image src={require('../../images/error.svg')} alt='' />
      </div>
      <div className={`popup-title ${isMobile ? 'm-title' : 'l-title'}`} dangerouslySetInnerHTML={{__html: props.title}} />
      <div className='bank-account-mismatch-popup__text' dangerouslySetInnerHTML={{__html: props.subTitle}} />
      <div className='debt-payment-popup-actions'>
        <BtnSubmit onclick={handleClose} text='הבנתי, תודה' />
      </div>
    </div>
  );
};

export default BankAccountMismatchPopup;
